<!-- サインアップパスワードコンポーネント -->
<template>
    <dd>
        <template v-if="validate.$error">
            <span v-if="!validate.required" class="errNote">パスワードを入力してください。</span>
            <span v-if="!validate.passwordRule" class="errNote">パスワードは大文字英・小文字英・数字・記号の中から3種以上で入力してください。</span>
            <span v-if="!validate.minLength || !validate.maxLength" class="errNote">
                パスワードは{{ validate.$params.minLength.min }}文字以上{{ validate.$params.maxLength.max }}文字以下で入力してください。
            </span>
        </template>
        <div class="pswdShowHide">
            <input v-model="validate.$model"
                   :type="inputType"
                   name="password"
                   placeholder="パスワード"
                   id="passwordInput"
                   class="regular">
            <i :class="iconClass" @click="toggle">パスワード表示/非表示</i>
        </div>
        <span class="annotation" style="margin-top: 6px">
        パスワードは、8文字以上20文字以下の半角英数と記号を指定してください。<br>
        数字、大文字の英数、小文字の英数、記号から3種類を含める必要があります。
    </span>
    </dd>
</template>

<script>
export default {
    name: 'UserInfoPasswordField',
    data: function(){
        return {
            isShowPassword: false,
        }
    },
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    computed: {
        iconClass: function(){
            const klass = this.isShowPassword? 'show': '';
            return ['pwSwitch', klass];
        },
        inputType: function(){
            return (this.isShowPassword) ? 'text': 'password';
        }
    },
    methods: {
        toggle: function(){
            this.isShowPassword = !this.isShowPassword;
        },
        setUserInfoPatch: function(ev){
            const key = ev.target.name;
            const value = ev.target.value;
            this.$emit('set-user-info-patch', key, value);
        }
    }
}
</script>
